// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"cedc1820","636":"eb7f0090"}[chunkId] + ".chunk.js";
};